module.exports = __webpack_public_path__ + "static/media/miroslav-400-400.695a7d04.png";